import React from 'react';
import '../App.css'; // 引入樣式文件
import { useTranslation } from 'react-i18next';

function ValuationModels() {
  const { t } = useTranslation(); // 預設使用 translation namespace

  return (
    <div className="article-container">
      <h1>{t('valuationModelsIntro.title')}</h1>
      <p>{t('valuationModelsIntro.paragraph1')}</p>
      <p>{t('valuationModelsIntro.paragraph2')}</p>
      <p>{t('valuationModelsIntro.paragraph3')}</p>
    </div>
  );
}

export default ValuationModels;
